<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="pl-3" @click="loadOwners">
      <div>
        <v-icon>mdi-account-key-outline</v-icon>
        <span class="ml-1">Entra ID Owners</span>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-alert v-if="errorMessage" type="error" outlined dense>{{ errorMessage }}</v-alert>
      <v-alert v-if="pendingMessage" type="warning" outlined dense>{{ pendingMessage }}</v-alert>
      <v-progress-linear v-if="loading" indeterminate color="#006c27" class="mb-3" />
      <template v-if="status">
        <div class="text-subtitle-2 text-left mb-2">Application registration owners</div>
        <v-simple-table dense class="mb-4">
          <template v-slot:default>
            <thead><tr><th>Name</th><th>Type</th><th>Object ID</th></tr></thead>
            <tbody>
              <tr v-for="owner in status.applicationRegistrationOwners" :key="'app-' + owner.objectId">
                <td>{{ owner.displayName || '-' }}</td><td>{{ owner.objectType }}</td><td class="text-caption">{{ owner.objectId }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <div class="text-subtitle-2 text-left mb-2">Service principal owners</div>
        <v-simple-table dense class="mb-4">
          <template v-slot:default>
            <thead><tr><th>Name</th><th>Type</th><th>Object ID</th></tr></thead>
            <tbody>
              <tr v-for="owner in status.servicePrincipalOwners" :key="'sp-' + owner.objectId">
                <td>{{ owner.displayName || '-' }}</td><td>{{ owner.objectType }}</td><td class="text-caption">{{ owner.objectId }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-alert v-if="status.state === 'INCONSISTENT'" type="warning" outlined dense>
          Your ownership differs between the application registration and service principal. The action is disabled until Entra ID is consistent.
        </v-alert>
        <div class="text-right">
          <v-btn :disabled="loading || updating || pendingMessage || status.state === 'INCONSISTENT'" class="white--text" color="#006c27" @click="toggleOwnership">
            <v-progress-circular v-if="updating" indeterminate size="18" width="2" class="mr-2" />
            {{ status.state === 'OWNED' ? 'Remove myself as Entra owner' : 'Add myself as Entra owner' }}
          </v-btn>
        </div>
      </template>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import cass from "../api/cass";

export default {
  name: "EntraOwners",
  props: { application: Object },
  data() { return { status: null, loading: false, updating: false, errorMessage: "", pendingMessage: "" }; },
  methods: {
    loadOwners() {
      if (this.loading || this.status) return;
      this.loading = true;
      cass.getEntraOwnership(this.application.applicationId)
        .then((response) => { this.status = response.data; })
        .catch((error) => { this.errorMessage = cass.handleError(error).message; })
        .finally(() => { this.loading = false; });
    },
    toggleOwnership() {
      this.updating = true;
      this.errorMessage = "";
      const request = this.status.state === "OWNED"
        ? cass.removeEntraOwner(this.application.applicationId)
        : cass.addEntraOwner(this.application.applicationId);
      request.then((response) => {
        if (response.status === 202) {
          this.pendingMessage = response.data.message;
          return;
        }
        this.status = null;
        this.loadOwners();
      }).catch((error) => { this.errorMessage = cass.handleError(error).message; })
        .finally(() => { this.updating = false; });
    },
  },
};
</script>
